export default __webpack_public_path__ + "static/media/todayOrders.023aaa12.svg";